import React from 'react';
import { useTheme } from '@emotion/react';
import { Box, Skeleton, Step, StepLabel, Stepper, Typography } from '@mui/material';
import BreadcrumbHeader from 'layout/BreadcrumbsHeader';
import ThemeBGWrapper from 'ui-components/ThemeBGWrapper';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { containerRef } from 'utils';
import AssessmentFooter from '../components/AssessmentFooter';

const STEPS = ['Select Pitch Decks', 'Investment Thesis'];

const BulkAnalysisStartSkeleton = () => {
  const theme = useTheme();
  const c = theme.palette.customColors;

  return (
    <ThemeBGWrapper>
      <PerfectScrollbar containerRef={containerRef} style={{ height: '100%' }}>
        <BreadcrumbHeader
          title="Bulk Pitch Deck Analysis"
          breadcrumbItems={[
            { title: 'Tools', path: '' },
            { title: 'Analyze Decks' },
          ]}
        />

        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', px: 2, pb: 4, minHeight: 'calc(100vh - 200px)' }}>
          <Box
            sx={{
              width: '100%',
              maxWidth: 520,
              backgroundColor: c.whiteBG,
              borderRadius: '20px',
              boxShadow: '0 4px 24px rgba(0,0,0,0.07)',
              p: { xs: '1.5rem', sm: '2rem' },
            }}
          >
            {/* Stepper */}
            <Stepper activeStep={0} alternativeLabel sx={{ mb: 3 }}>
              {STEPS.map((label) => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>

            {/* Content Skeleton */}
            <Box>
              {/* Upload area skeleton */}
              <Skeleton
                variant="rectangular"
                width="100%"
                height={200}
                sx={{ borderRadius: '12px', mb: 2.5 }}
              />

              {/* Continue button skeleton */}
              <Skeleton
                variant="rectangular"
                width="100%"
                height={48}
                sx={{ borderRadius: '10px', mb: 1.5 }}
              />
            </Box>

            {/* Footer */}
            <AssessmentFooter />
          </Box>
        </Box>
      </PerfectScrollbar>
    </ThemeBGWrapper>
  );
};

export default BulkAnalysisStartSkeleton;
